const exhibition = {
    getParentTypes: { api: '/api.php/Exhibition/getParentTypes', },
    getChildTypes: { api: '/api.php/Exhibition/getChildTypes', },
    getLists: { api: '/api.php/Exhibition/getLists', },
    getDetail: { api: '/api.php/Exhibition/getDetail', },
    getProductDetail: { api: '/api.php/Exhibition/getProductDetail', },
    getProductLists: { api: '/api.php/Exhibition/getProductLists ', },
}
export default exhibition
